import { render, staticRenderFns } from "./SentimentResponse.vue?vue&type=template&id=4064ebfe&scoped=true&"
import script from "./SentimentResponse.vue?vue&type=script&lang=js&"
export * from "./SentimentResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064ebfe",
  null
  
)

export default component.exports